import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Rect } from "react-native-svg";

export default function EmptyStar(props) {
  const width = props.width || 38;
  const height = props.height || 38;
  const color = props.color || "#FCE152";

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Rect width="38" height="38" fill="white" />
        <Path
          d="M8.60716 10.4489L6.33607 9.30672C6.2579 9.26664 6.17132 9.24573 6.08348 9.24573C5.99564 9.24573 5.90905 9.26664 5.83089 9.30672L3.60373 10.5411C3.51482 10.5896 3.41416 10.6123 3.31306 10.6067C3.21197 10.6011 3.11442 10.5674 3.03139 10.5095C2.94835 10.4516 2.88311 10.3716 2.84299 10.2787C2.80286 10.1857 2.78944 10.0834 2.80423 9.98322L3.1908 7.49249C3.20389 7.40512 3.19553 7.31588 3.16645 7.23247C3.13737 7.14905 3.08844 7.07396 3.02387 7.01367L1.17449 5.25654C1.09976 5.18779 1.04592 5.09937 1.01914 5.00142C0.992351 4.90347 0.99371 4.79996 1.02306 4.70274C1.0524 4.60553 1.10855 4.51856 1.18506 4.45179C1.26157 4.38503 1.35535 4.34117 1.45564 4.32526L3.9859 3.90794C4.07312 3.89491 4.15573 3.86038 4.22628 3.80747C4.29684 3.75455 4.35311 3.68492 4.39004 3.60483L5.47507 1.30299C5.51951 1.21211 5.58856 1.13553 5.67437 1.08197C5.76019 1.0284 5.85932 1 5.96048 1C6.06164 1 6.16077 1.0284 6.24659 1.08197C6.3324 1.13553 6.40145 1.21211 6.44589 1.30299L7.59241 3.53894C7.6327 3.61663 7.6914 3.68328 7.76338 3.73305C7.83536 3.78282 7.91843 3.81421 8.00534 3.82448L10.5268 4.14515C10.6273 4.15846 10.722 4.19951 10.8004 4.26369C10.8788 4.32787 10.9377 4.41265 10.9706 4.50848C11.0034 4.60432 11.0089 4.70742 10.9864 4.8062C10.9639 4.90497 10.9142 4.99551 10.8431 5.06765L9.05523 6.8731C8.99389 6.93598 8.94867 7.01277 8.92343 7.09691C8.89819 7.18105 8.89367 7.27004 8.91026 7.35631L9.38469 9.85583C9.40626 9.95608 9.39886 10.0604 9.36335 10.1566C9.32783 10.2528 9.26568 10.3369 9.18414 10.3991C9.1026 10.4613 9.00505 10.499 8.90288 10.5078C8.80071 10.5166 8.69814 10.4962 8.60716 10.4489V10.4489Z"
          stroke={color}
          strokeWidth="1.05867"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </TouchableOpacity>
  );
}
